/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {geocodeUnit} from '../api'

export const useMutationGeocodeUnit = createReactQueryMutationHook('geocodeUnit', geocodeUnit)
